<template>
  <div 
    class="section-spacing max-w-[1500px] mx-auto bg-cover bg-left-top bg-no-repeat"
    :class="[bgColorClass === 'bg-white' ? '' : 'py-40px', bgColorClass]"
    :style="[bgImageStyle]">
    <slot>
      <div class="w-full h-32"></div>
    </slot>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useIsBgColor } from '../../compostables/useValidators';


export default {
  props: {
    bgColor: {
      type: String,
      required: false,
      default: 'blue',
      validator(value) {
          return useIsBgColor(value);
      }
    },
    bgImage: {
      type: String,
      required: false,
      default: null
    },
  },

  setup(props) {
    const bgImageStyle = (props.bgImage !== null) ? 'backgroundImage: url(' + props.bgImage + ')' : '';
    const bgColorClass = computed(() => {
      switch (props.bgColor) {
        case 'navy':
          return 'bg-navy';
          break;
      
        case 'gray':
          return 'bg-light-gray-400';
          break;
      
        case 'orange':
          return 'bg-orange-100';
          break;
      
        case 'dark orange':
          return 'bg-orange-300';
          break;
      
        case 'blue':
          return 'bg-light-blue-2';
          break;

        default:
          return 'bg-white';
          break;
      }
    });

    return {
      bgColorClass,
      bgImageStyle
    }

  }

}
</script>

<style>

</style>